import LoansDisbursedChart from './loans/LoansDisbursedChart';
import LoansOutstandingChart from './loans/LoansOutstandingChart';
import LoansRepaymentChart from './loans/LoansRepaymentChart';
import LoansDefaultedChart from './loans/LoansDefaultedChart';

import MembershipActiveChart from './membership/MembershipActiveChart';
import MembershipNewChart from './membership/MembershipNewChart';
import MembershipRetentionChart from './membership/MembershipRetentionChart';
import MembershipRegionChart from './membership/MembershipRegionChart';

import InsurancePremiumsChart from './insurance/InsurancePremiumsChart';
import InsuranceClaimsChart from './insurance/InsuranceClaimsChart';
import InsurancePoliciesChart from './insurance/InsurancePoliciesChart';
import InsuranceRatioChart from './insurance/InsuranceRatioChart';

import HospitalityOccupancyChart from './hospitality/HospitalityOccupancyChart';
import HospitalityRevenueChart from './hospitality/HospitalityRevenueChart';
import HospitalityEventsChart from './hospitality/HospitalityEventsChart';
import HospitalitySatisfactionChart from './hospitality/HospitalitySatisfactionChart';
import LoansZwd from './loans/LoansZwd';

// Maps a metric ID (from dashboard-data.js) to its dedicated chart component.
const chartRegistry = {
  'loans-disbursed': LoansDisbursedChart,
  'loans-outstanding': LoansOutstandingChart,
  'loans-zim': LoansZwd,
  'loans-repayment': LoansRepaymentChart,
  'loans-defaulted': LoansDefaultedChart,

  'mem-active': MembershipActiveChart,
  'mem-new': MembershipNewChart,
  'mem-retention': MembershipRetentionChart,
  'mem-region': MembershipRegionChart,

  'ins-premiums': InsurancePremiumsChart,
  'ins-claims': InsuranceClaimsChart,
  'ins-policies': InsurancePoliciesChart,
  'ins-ratio': InsuranceRatioChart,

  'hosp-occupancy': HospitalityOccupancyChart,
  'hosp-revenue': HospitalityRevenueChart,
  'hosp-events': HospitalityEventsChart,
  'hosp-satisfaction': HospitalitySatisfactionChart
};

export default chartRegistry;
